// @flow
import React, { PureComponent } from 'react';
import { socialNetworks } from 'utils/socialShareUtils';

type Props = {
  url: string,
  title: string,
  titleclass: string,
  clickTagManager: Function
};

class FooterSocial extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    title: '',
    titleclass: 'mb-3'
  };

  renderButtons = (): Array<React$Element<any>> => {
    const { clickTagManager } = this.props;
    const { url, title } = this.props;

    return Object.keys(socialNetworks).map(key => {
      const ShareButton = socialNetworks[key];
      const classNames = key === 'mail' ? 'btn btn--primary btn--social' :
        `btn btn--${key} btn--social`;
      const socialNetworkTitle = key.substr(0, 1).toUpperCase() + key.slice(1);

      return (
        <ShareButton
          resetButtonStyle={false}
          className={`${classNames}${key === 'twitter' ? ' is-dark' : ''}`}
          key={`${key}-share-button`}
          url={(!url || url === '#') ? window.location.href : url}
          quote={title}
          subject={title}
          title={title}
          beforeOnClick={clickTagManager(key)}>
          <i className={`icon icon-${key} is-inline`} />
          <span>{socialNetworkTitle}</span>
        </ShareButton>
      );
    });
  }

  render() {
    return (
      <div>
        <h3 className={this.props.titleclass}>Partager</h3>
        <div className="block-share">
          {this.renderButtons()}
        </div>
      </div>
    );
  }
}
export default FooterSocial;
